<template>
  <div >
      <div style="color:#fff;">
  <h1>Wreck Data</h1>
   </div>
  <EditableDocument v-for="(wrecks,i) in wrecksText" :key="'wrecks'+i" class="blackBG alignLeft padSide" :collection="'Documents'" :textID="i">
    
   </EditableDocument> 
 
  </div>
</template>

<script>
import EditableContent from '../components/EditableContent'
import EditableDocument from '../components/EditableDocument'

export default {
  components: {
    EditableContent,
    EditableDocument
  },
  data() {
    return {
      wrecksText:null
    }
  },
  mounted(){
     this.$store.dispatch('loadText','Documents')
    },
    computed:{
      loadingText(){
        return this.$store.getters.loadingText
      },
    },
    methods:{
     saveHelp(html){
       this.$store.dispatch("saveSpecificText",{type:"Playing",content:html})
     }
    },
    watch:{
      loadingText(val){
        if(!val){
          this.$store.commit('loading',true)
          //this.wrecksText=this.$store.getters.getLoadedCollection("Wrecks")
          this.wrecksText=this.$store.getters.getLoadedText("Documents")
     
        }
        console.log("Loading status",val)
      },
      wrecksText(){
        this.$nextTick().then(() => {
          this.$store.commit('loading',false)
        })
      }
    },
  beforeDestroy() {
    
  },
}
</script>
<style>

.blackBG{
  color:#fff;
  background-color: #000;
}
.whiteBG{
  color:#000;
  background-color: #fff;
}
.alignLeft{
  text-align: left;
}
.padSide{
  padding-left: 50px;
  padding-right: 50px;
}

</style>